import { useMemo, useState } from 'react';

import { ia, inRn } from 'lib/helpers/utility';

import InvoiceSummary from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceFooter/InvoiceSummary/InvoiceSummary';
import Switch from 'components/shared/Switch/Switch';
import Transition from 'components/shared/Transition/Transition';
import Typography from 'components/shared/Typography/Typography';

import { INFORMATION_ITEMS } from '../../lib/constants';
import { getTotals } from '../../lib/helpers';

import InformationItem from './InformationItem';
import Invoices from './Invoices';

const InvoiceDetails = ({ invoice }) => {
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const internalInvoices = invoice?.internal_invoices || [];

  const totals = useMemo(() => getTotals(internalInvoices), [internalInvoices]);

  const surchargeAmount = inRn(invoice?.surcharge_amount);

  return (
    <>
      <div className="flex justify-between gap-3 border-0 border-y border-solid border-neutral-200 px-6 py-3 sm:flex-col sm:px-2">
        <div className="flex flex-col gap-2">
          {INFORMATION_ITEMS.map((item) => (
            <InformationItem key={item.text} {...item} />
          ))}
        </div>
        {ia(internalInvoices) && (
          <div className="flex items-start gap-1.5">
            <Switch checked={showInvoiceDetails} onChange={setShowInvoiceDetails} />
            <Typography variant="label" size="small" weight="medium" color="neutral-700">
              Show invoice details
            </Typography>
          </div>
        )}
      </div>
      <Transition
        isOpen={showInvoiceDetails}
        type="slide-down"
        duration={{ enter: 300, leave: 300 }}>
        <div className="py-4 sm:py-0">
          <Invoices invoices={internalInvoices} />
          <InvoiceSummary
            total={inRn(totals?.dueAmount) + surchargeAmount}
            subTotal={totals?.total}
            technologyFee={surchargeAmount}
            stateTax={totals?.stateTax}
            localTax={totals?.localTax}
            discount={totals?.discount}
            writeOffs={totals?.write_off}
            otherAdjustments={totals?.otherAdjustments}
            preview
          />
        </div>
      </Transition>
    </>
  );
};

export default InvoiceDetails;
